import { render, staticRenderFns } from "./ModalRequestComponent.vue?vue&type=template&id=2a323664"
import script from "./ModalRequestComponent.vue?vue&type=script&lang=js"
export * from "./ModalRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports